import React, { useEffect, useState } from 'react';
import axios from 'axios';

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const blank = { question: '', answer: '' };
const SERVICE_PREFIX = '__JEI_SERVICE__:';

export default function FaqManagement() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(blank);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const load = () => axios.get('/faq').then(({ data }) => setItems(data.filter((x) => !x.deletedAt && !x.question?.startsWith(SERVICE_PREFIX)))).catch(() => setError('Impossible de charger la FAQ.'));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault(); setError('');
    try {
      if (editingId) await axios.patch(`/faq/${editingId}`, form, { headers: headers() });
      else await axios.post('/faq', form, { headers: headers() });
      setForm(blank); setEditingId(null); load();
    } catch (err) { setError(err.response?.data?.message || 'Enregistrement impossible.'); }
  };
  const edit = (item) => { setEditingId(item.id); setForm({ question: item.question, answer: item.answer }); window.scrollTo({ top: 0, behavior: 'smooth' }); };
  const remove = async (id) => { if (!window.confirm('Supprimer cette question ?')) return; await axios.delete(`/faq/${id}`, { headers: headers() }); load(); };

  return <main style={{ maxWidth: 1050, margin: '40px auto', padding: '0 24px', color: '#05012a' }}>
    <h1>Gestion de la FAQ</h1><p style={{ color: '#666' }}>Ajoutez ou modifiez les questions affichées sur le site.</p>
    <form onSubmit={submit} className="form-card" style={{ margin: '26px 0', padding: 24 }}>
      <div className="form-group"><label className="form-label">Question</label><input className="form-input" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} required /></div>
      <div className="form-group"><label className="form-label">Réponse</label><textarea className="form-textarea" rows="5" value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} required /></div>
      <div style={{ display: 'flex', gap: 12 }}><button className="btn-save" type="submit">{editingId ? 'Mettre à jour' : 'Ajouter'}</button>{editingId && <button type="button" onClick={() => { setEditingId(null); setForm(blank); }}>Annuler</button>}</div>
      {error && <p style={{ color: '#b5122b' }}>{String(error)}</p>}
    </form>
    <div style={{ display: 'grid', gap: 14 }}>{items.map((item) => <article key={item.id} style={{ background: '#fff', border: '1px solid #e4e4ec', borderRadius: 12, padding: 20 }}><strong>{item.question}</strong><p style={{ color: '#403b59', lineHeight: 1.6 }}>{item.answer}</p><div style={{ display: 'flex', gap: 10 }}><button onClick={() => edit(item)}>Modifier</button><button onClick={() => remove(item.id)} style={{ color: '#b5122b' }}>Supprimer</button></div></article>)}</div>
  </main>;
}
